<template>
    <v-img :src="`${addressRecord.thumbImageUrl}?ts=${cacheBuster}`" width="100px" height="80px" class="preview-icons">
        <a v-if="!hidePreview" :href="addressRecord.detailPreviewUrl" :title="$t('prev_detail')" target="_blank"
            ><i class="ic ic-20 ic-preview ic-col-black"></i
        ></a>
        <a v-if="!hidePreview" :href="addressRecord.searchPreviewUrl" :title="$t('prev_list')" target="_blank"
            ><i class="ic ic-20 ic-list ic-col-black"></i
        ></a>
    </v-img>
</template>

<script>
import { Address } from '@/models/Address';
import { globalParam } from '@/helpers/globals';
/**
 * Image component used in the Address List: displays the address' image and
 * overlays links to the frontend preview versions.
 */
export default {
    name: 'AddressListImageWithPrevLinks',
    props: {
        addressRecord: {
            type: Address,
            required: true,
        },
    },
    data() {
        return {
            cacheBuster: new Date().getTime(),
        };
    },
    computed: {
        hidePreview() {
            return globalParam('address.hide_preview');
        },
    },
};
</script>

<style lang="scss" scoped>
.preview-icons {
    ::v-deep {
        .v-responsive__content {
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;

            a {
                width: 22px;
                height: 22px;
                display: inline-block;
                background-color: var(--tgk-grey-5);
                opacity: 0.4;
                .ic {
                    opacity: 0.4;
                }

                &:hover {
                    opacity: 1;
                    .ic {
                        opacity: 1;
                    }
                }
            }
        }
    }
}
</style>
